import type {Logger} from '@feature-hub/core';
import type {SelectedVehicleV1} from '../v1.js';

const storageKey = `smart-selected-vehicle-v1`;

const storage =
  typeof window === `undefined` ? undefined : window.sessionStorage;

export function writeSelectedVehicleToStorage(
  selectedVehicle: SelectedVehicleV1 | undefined,
  logger: Logger = console,
): void {
  if (!storage) {
    return;
  }

  try {
    if (selectedVehicle) {
      storage.setItem(storageKey, JSON.stringify(selectedVehicle));
    } else {
      storage.removeItem(storageKey);
    }
  } catch (error) {
    logger.error(error);
  }
}

export function readSelectedVehicleFromStorage(
  logger: Logger = console,
): SelectedVehicleV1 | undefined {
  if (!storage) {
    return undefined;
  }

  try {
    const stringifiedSelectedVehicle = storage.getItem(storageKey);

    return stringifiedSelectedVehicle
      ? JSON.parse(stringifiedSelectedVehicle)
      : undefined;
  } catch (error) {
    logger.error(error);

    return undefined;
  }
}
